import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 8V6c0-2.2-1.8-4-4-4H8C5.8 2 4 3.8 4 6v2c-1.105 0-2 .895-2 2v7c0 1.105.895 2 2 2h11c1.105 0 2-.895 2-2v-7c0-1.105-.895-2-2-2zM5 6c0-1.654 1.346-3 3-3h3c1.654 0 3 1.346 3 3v2H5V6zm7.354 7.854l-2.5 2.5c-.098.098-.226.146-.354.146s-.256-.049-.354-.146a.5003.5003 0 0 1 0-.707l1.646-1.646H6.499c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h4.293l-1.646-1.646c-.195-.195-.195-.512 0-.707s.512-.195.707 0l2.5 2.5c.195.195.195.512 0 .707z',
  ],
  height: 20,
  width: 20,
});
